import React, { useState } from 'react';
import Link from 'next/link';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './gate.module.scss';

const cx = classnames.bind(styles);

const Gate = () => {
  const [listEnter, setListEnter] = useState([true, false, false]);

  const handleListEnter = (index: number) => {
    const listIndex = [false, false, false];

    listIndex[index] = true;
    setListEnter(listIndex);
  };

  return (
    <div className={cx('wrap')}>
      <div className={cx('titleArea')}>
        <strong className={cx('title')}>
          (구)역검 준비는 <span className={cx('emphasis')}>여기에서 끝!</span>
        </strong>
        <p className={cx('desc')}>
          * 잡다매칭과 불러오기 서비스를 이용하실 분들은
          <br />
          상단 메뉴의 {`'역량센터'`}를 이용해 주세요!
        </p>
      </div>

      <ul className={cx('infoList')}>
        {/* 역검 수련 */}
        <li className={cx('listItem', 'tutorial', { on: listEnter[0] })} onMouseEnter={() => handleListEnter(0)}>
          <Link href="/acc/tutorial" legacyBehavior>
            <a className={cx('link')} role="button">
              <span className={cx('text')}>실전과 똑같은 환경에서</span>
              <strong className={cx('title')}>역검 수련</strong>
              <div className={cx('pointListArea')}>
                <span className={cx('pointTitle')}>CHECK POINT</span>
                <ul className={cx('pointList')}>
                  <li className={cx('listItem')}>
                    <span className={cx('emphasis')}>실전과 100% 똑같은 환경</span>에서 체험할 수 있어요.
                  </li>
                  <li className={cx('listItem')}>
                    <span className={cx('emphasis')}>전략게임 숙련도</span>를 차근차근 올리고
                    <br />
                    <span className={cx('emphasis')}>게임별 진단결과</span>도 확인할 수 있어요.
                  </li>
                  <li className={cx('listItem')}>
                    익숙하지 않았던 <span className={cx('emphasis')}>영상면접</span>을 대비할 수 있어요.
                  </li>
                </ul>
              </div>
              <span className={cx('btn')}>수련하기</span>
            </a>
          </Link>
        </li>

        {/* 역검 비법 */}
        <li className={cx('listItem', 'secret', { on: listEnter[1] })} onMouseEnter={() => handleListEnter(1)}>
          <a href={RouteUrl.ACC_TIP} className={cx('link')} target="_blank" rel="noreferrer">
            <span className={cx('text')}>역검의 모든것</span>
            <strong className={cx('title')}>역검 비법</strong>
            <div className={cx('pointListArea')}>
              <span className={cx('pointTitle')}>CHECK POINT</span>
              <ul className={cx('pointList')}>
                <li className={cx('listItem')}>
                  <span className={cx('emphasis')}>공식개발사가 말하는 역검의 정확한 응시방법</span>
                  을<br /> 확인할 수 있어요.
                </li>
                <li className={cx('listItem')}>
                  역검의 <span className={cx('emphasis')}>평가 알고리즘</span>을 볼 수 있어요.
                </li>
                <li className={cx('listItem')}>
                  역검에 대한 <span className={cx('emphasis')}>궁금점과 오해와 진실</span>
                  을 해결할 수 <br />
                  있어요.
                </li>
              </ul>
            </div>
            <span className={cx('btn')}>비법 파헤치기</span>
          </a>
        </li>

        {/* 역량을 잡다란? */}
        <li className={cx('listItem', 'introduce', { on: listEnter[2] })} onMouseEnter={() => handleListEnter(2)}>
          <Link href="/acc/introduce" legacyBehavior>
            <a className={cx('link')} role="button">
              <span className={cx('text')}>역검이란 바로 이런것</span>
              <strong className={cx('title')}>역량을 잡다란?</strong>
              <div className={cx('pointListArea')}>
                <span className={cx('pointTitle')}>CHECK POINT</span>
                <ul className={cx('pointList')}>
                  <li className={cx('listItem')}>
                    잡다에서 정의하는 <span className={cx('emphasis')}>역량이 무엇인지</span> 확인할 수
                    <br />
                    있어요.
                  </li>
                  <li className={cx('listItem')}>
                    잡다에서 제공하는 <span className={cx('emphasis')}>역량 기반 리포트</span>가 <br />
                    어떤 내용으로 구성되어 있는지 확인할 수 있어요.
                  </li>
                  <li className={cx('listItem')}>
                    인적성검사와 <span className={cx('emphasis')}>역검의 차별점</span>이 무엇인지 확인할 수
                    <br />
                    있어요.
                  </li>
                </ul>
              </div>
              <span className={cx('btn')}>자세히 알아보기</span>
            </a>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Gate;
